import { render } from "./Home.vue?vue&type=template&id=0abb1960"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0abb1960&lang=scss"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__